import React from 'react';
import { AlignLeft, Users, Gem } from 'lucide-react';
import { triggerHaptic } from '../../utils/haptics';

export const ChatHeader = ({
  isEditingUserName,
  tempUserName,
  userName,
  _t,
  onStartEditingName,
  onSaveName,
  onNameChange,
  onKeyPressName,
  onToggleSidebar,
  onToggleGroups,
  onToggleSubscription
}) => {
  return (
    <div className="sticky top-0 left-0 w-full py-3 px-4 z-40 safe-top flex items-center gap-4 bg-[#050510]/80 backdrop-blur-xl">
      {/* Drawer icon */}
      <button
        onClick={() => { triggerHaptic(); onToggleSidebar(); }}
        className="w-10 h-10 rounded-xl glass-card flex items-center justify-center text-white hover:bg-white/10 active:scale-95 transition-all flex-shrink-0"
      >
        <AlignLeft size={20} strokeWidth={1.5} />
      </button>

      {/* User name */}
      <div className="flex items-center">
        {isEditingUserName ? (
          <input
            type="text"
            value={tempUserName}
            onChange={(e) => {
              if (e.target.value.length <= 10) {
                onNameChange(e.target.value);
              }
            }}
            onBlur={onSaveName}
            onKeyPress={onKeyPressName}
            className="text-base font-bold text-white bg-transparent border-b border-[var(--neon-primary)]/50 outline-none focus:border-[var(--neon-primary)] px-1 py-0.5 w-24 text-center"
            autoFocus
            maxLength={10}
          />
        ) : (
          <span
            className="text-base font-bold text-white cursor-pointer hover:text-[var(--neon-primary)] transition-colors"
            onClick={onStartEditingName}
          >
            {userName}
          </span>
        )}
      </div>

      {/* Action icons */}
      <div className="flex items-center gap-2 ml-auto">
        <button
          onClick={() => { triggerHaptic(); onToggleGroups(); }}
          className="w-9 h-9 rounded-lg glass-card border border-[var(--neon-primary)]/30 flex items-center justify-center text-[var(--neon-primary)] hover:bg-[var(--neon-primary)]/10 active:scale-95 transition-all"
          title="群聊"
        >
          <Users size={18} strokeWidth={1.5} />
        </button>
        <button
          onClick={() => { triggerHaptic(); onToggleSubscription(); }}
          className="w-9 h-9 rounded-lg glass-card border border-[var(--neon-warning)]/30 flex items-center justify-center text-[var(--neon-warning)] hover:bg-[var(--neon-warning)]/10 active:scale-95 transition-all"
          title="订阅"
        >
          <Gem size={18} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
};

export default ChatHeader;
